import Button from '@mui/material/Button';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import ExtraInformation from '/@/components/map/extra-information';
import ReferenceItems from '/@/components/map/reference-items';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Select from '/@/v3/components/forms/select';
import styles from './styles.module.css';

@autobind
export default class OverlayReference extends Component {
    static propTypes = {
        overlay: PropTypes.object,
        version: PropTypes.object,
        values: PropTypes.array,
        onOverlayChange: PropTypes.func,
    };

    state = {
        showExtraInformation: false,
    };

    showExtraInformation() {
        this.setState({ showExtraInformation: true });
    }

    hideExtraInformation() {
        this.setState({ showExtraInformation: false });
    }

    handleVersionChange(value) {
        this.props.onOverlayChange({
            type: this.props.overlay.slug,
            version: value,
        });
    }

    renderVersionSelect(versions) {
        if (this.props.values) {
            versions = versions.filter(({ referenceItems }) =>
                referenceItems.some(({ id }) => this.props.values.includes(id))
            );
        }

        return (
            <div className={styles.version}>
                <Select
                    color={settings.app.theme}
                    size='sm'
                    disabled={versions.length <= 1}
                    value={this.props.version.versionNumber}
                    options={versions.map((version) => ({
                        value: version.versionNumber,
                        label: _(version.versionLabel),
                    }))}
                    clearable={false}
                    onChange={this.handleVersionChange}
                />
            </div>
        );
    }

    renderSingle() {
        const name = _(this.props.overlay.name);
        const unit = _(this.props.version.referenceUnit);
        const items = this.props.version.mapValues.filter(({ id }) => this.props.values.includes(id));

        if (items.length === 0) return null;

        return (
            <div className={classNames(styles.root, styles.single, this.props.className)}>
                <div className={styles.header}>
                    <div className={styles.name}>{name}</div>
                    {this.renderVersionSelect(this.props.overlay.versions)}
                </div>
                <div className={styles.footer}>
                    <div className={styles.label}>{`${_('Unidad:')} ${unit}`}</div>
                    <ReferenceItems items={items} />
                </div>
            </div>
        );
    }

    renderFull() {
        const { showExtraInformation } = this.state;
        const name = _(this.props.overlay.name);
        const unit = _(this.props.version.referenceUnit);
        const source = _(this.props.version.source);
        const description = _(this.props.version.description);
        const extraInformation = _(this.props.version.extraInformation);
        const items = this.props.version.mapValues;

        return (
            <div className={classNames(styles.root, styles.full, this.props.className)}>
                <div className={styles.header}>
                    <div className={styles.name}>{name}</div>
                    {this.renderVersionSelect(this.props.overlay.versions)}
                </div>
                {unit && (
                    <div className={styles.unit}>
                        <span>{`${_('Unidad:')} `}</span>
                        <ReactMarkdown className={styles.unitMd}>{unit}</ReactMarkdown>
                    </div>
                )}
                <ReferenceItems items={items} />
                {description && <div className={styles.description}>{description}</div>}
                <div className={styles.footer}>
                    {source && <div className={styles.description}>{`${_('Fuente:')} ${source}`}</div>}
                    {extraInformation && (
                        <div onClick={this.showExtraInformation}>
                            <Button onClick={this.showExtraInformation} variant='outlined'>
                                {_('Más información')}
                            </Button>
                        </div>
                    )}
                </div>
                {extraInformation && (
                    <ExtraInformation
                        visible={showExtraInformation}
                        onClose={this.hideExtraInformation}
                        information={extraInformation}
                        referenceItems={this.props.version.mapValues}
                    />
                )}
            </div>
        );
    }

    render() {
        if (this.props.values) return this.renderSingle();
        return this.renderFull();
    }
}
